import React from "react";
import  '../../styles/configuracoesStyle/PasswordModal.css'

export default function PasswordModal({
  onConfirm,
  onCancel,
  password,
  setPassword,
}: {
  onConfirm: () => void;
  onCancel: () => void;
  password: string;
  setPassword: (v: string) => void;
}) {
  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <h3>Confirme sua senha</h3>
        <input
          type="password"
          placeholder="Senha atual"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <div className="modal-buttons">
          <button className="btn-submit" onClick={onConfirm}>
            Confirmar
          </button>
          <button className="btn-cancel" onClick={onCancel}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}
